import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    error: string;
    labelCopy: string;
    labelGoToShare: string;
    successWithRedirect: string;
    successWithoutRedirect: string;
    cancelledByUser: string;
    restrictedAssetsLimitReached: string;
    disableShareDownloadsNotInPlan: string;
    secureSharingNotInPlan: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message shown when Share creation fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.error?c=2yvd2mplgz7jr", defaultMessage: "There was a problem creating your Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to copy the Share link */
            labelCopy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.labelCopy?c=dcg75xyfkt13", defaultMessage: "Copy Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to navigate to the created Share */
            labelGoToShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.labelGoToShare?c=2fjtzscn0n8uc", defaultMessage: "Go to Share Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast message when Share is created and user navigates to it */
            successWithRedirect: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.successWithRedirect?c=3302dhqb6ksth", defaultMessage: "New Share Link created" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast message when Share is created and link is copied */
            successWithoutRedirect: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.successWithoutRedirect?c=tjxudismlcff", defaultMessage: "Share Link created and copied to clipboard" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message shown when user cancels Share creation */
            cancelledByUser: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.cancelledByUser?c=vdadp8dcupbu", defaultMessage: "Cancelled by user" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error shown when restricted assets limit is exceeded */
            restrictedAssetsLimitReached: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.restrictedAssetsLimitReached?c=2cgcez933v9fs", defaultMessage: "Can''t share items \u2013 this share would exceed the 250 restricted item limit." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error shown when plan lacks disable_share_downloads feature */
            disableShareDownloadsNotInPlan: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.disableShareDownloadsNotInPlan?c=3w16pau6046h4", defaultMessage: "Can''t share items - your plan is missing feature: disable_share_downloads. Please contact support for assistance." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error shown when plan lacks secure_sharing feature */
            secureSharingNotInPlan: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useCreateShare.secureSharingNotInPlan?c=3b8f8frq9lhqw", defaultMessage: "Can''t share items - your plan is missing feature: secure_sharing. Please contact support for assistance." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
